<template>
  <!-- Button: open sub menu -->
  <button v-if="hasChildren" type="button" @click="subMenuOpen = true">
    <MegaMenuItemEntryLabel
      v-bind="{
        megaMenuItem,
        hasChildren,
      }"
    />
  </button>

  <!-- Go to page -->
  <a v-else-if="megaMenuItem.url_key" :href="megaMenuItem.url_key">
    <MegaMenuItemEntryLabel
      v-bind="{
        megaMenuItem,
        hasChildren,
      }"
    />
  </a>

  <MegaMenuMobile
    v-if="megaMenuItem.children && megaMenuItem.children?.length > 0"
    v-model:open="subMenuOpen"
    :menu-items="megaMenuItem.children"
    :title="megaMenuItem.label"
  />
</template>

<script setup lang="ts">
import { MegaMenuItem } from '@/types/MegaMenu/MegaMenuItem';
import { PropType, ref } from 'vue';
import MegaMenuMobile from '@/partials/MegaMenuPartial/Partial/MegaMenuMobile.vue';
import MegaMenuItemEntryLabel from '@/partials/MegaMenuPartial/Partial/MegaMenuItemEntryLabel.vue';

const props = defineProps({
  megaMenuItem: {
    type: Object as PropType<MegaMenuItem>,
    required: true,
  },
});

const subMenuOpen = ref(false);

const hasChildren =
  !!props.megaMenuItem?.children && props.megaMenuItem.children.length > 0;
</script>
